import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const fetchRelacionMedicoPractica = (idEfectorRed) => async (dispatch) => {
    try {
        const response = await fetchConToken(`RelacionMedicoPractica/${idEfectorRed}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerRelacionMedicoPractica,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar las Relaciones.", "Ha ocurrido un error. Intente Nuevamente")
        dispatch({type: types.relacionMedicoPracticaError})
    }
}

export const agregarRelacionMedicoPractica = (idEfectorRed,idCentroMedico,idEspecialidad , codNom) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idEfectorRed : idEfectorRed,
           idCentroMedico: idCentroMedico,
           idEspecialidad: idEspecialidad,
           codNom: codNom
       }
       const response = await fetchConToken(`RelacionMedicoPractica/`, data, "POST");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Relacion creada correctamente", 'success', 'Comando Exitoso'));
            // dispatch({
            //     type: types.relacionTramiteAreaGuardar,
            //     payload: body
            // })
           dispatch(fetchRelacionMedicoPractica(idEfectorRed));
           dispatch(finishSpinner());
           
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al crear la Relacion.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const eliminarRelacionMedicoPractica = (idEfectorRed,idCentroMedico,idEspecialidad , codNom) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idEfectorRed : idEfectorRed,
           idCentroMedico: idCentroMedico,
           idEspecialidad: idEspecialidad,
           codNom: codNom
       }
       const response = await fetchConToken(`RelacionMedicoPractica/`, data, "DELETE");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Relacion eliminada correctamente", 'success', 'Comando Exitoso'));
            // dispatch({
            //     type: types.relacionTramiteAreaGuardar,
            //     payload: body
            // })
           dispatch(fetchRelacionMedicoPractica(idEfectorRed));
           dispatch(finishSpinner());
           
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al eliminar la Relacion.", "Ha ocurrido un error. Intente nuevamente")
   }
};